/**
 *  Order product list by featured ASC, createdAt DESC
 *
 * @param {Product} a
 * @param {Product} b
 * @return {number}
 */
export function sortProducts(a, b) {
  if (a.featured !== b.featured) {
    return a.featured ? -1 : 1;
  }

  return b.createdAt.localeCompare(a.createdAt);
}
